/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useRouteError } from 'react-router'
import { NoListHeader } from './NoListResult'
import ic_error from 'url:/assets/ic_error.svg'

export default function ErrorPage() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
  const error = useRouteError() as any
  console.error(error)

  return (
    <div className="flex justify-center items-center h-screen flex-col space-y-7">
      <div className="h-56 w-56 bg-sidebarBackgroundColor rounded-full flex justify-center">
        <img src={ic_error} alt="" />
      </div>
      <NoListHeader>An unexpected error occurred</NoListHeader>

      <p className=" text-center">
        Your request could not be processed. It the problem persists, please contact your
        administrator.
      </p>
    </div>
  )
}
